<template>
  <div id="tvChannel">
    <section class="our_team" id="tv">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div class="title">
              <h3>ТЕЛЕВИЗИЙН ҮЙЛЧИЛГЭЭ</h3>
              <div class="underline"></div>
              <p>Манай компани нь Монголсат ХХК-с үзүүлж буй 80 гаруй сувгийг сарын суурь хураамжгүй үзэх үйлчилгээний хүлээн авагч төхөөрөмжийн албан ёсны борлуулагчаар ажиллаж байна.</p>
              <a href="https://www.mongolsat.mn/">
              <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
              СУВГУУДЫН ЖАГСААЛТ 
              </a>
            </div>
            <!--/.title-->
          </div>

          <div class="w-100"></div>
          <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.1s">
            <div class="team_single">
              <div style="padding-top:0px; text-align:left;">
                <div class="padding-top-bottom-content" style="background-color:#f26322;">
                  <h3 style="color: white; margin-bottom: 0px; padding-left: 20px;">
                    <span style="font-family: &quot;Times New Roman&quot;;">"ЗОЛТ" худалдааны төв</span>
                  </h3>
                </div>
                <div>
                  <div
                    style="padding:20px; background-color:#f1f1f1; border-right:5px solid #f26322; border-left:1px solid #f26322;"
                  >
                    <p>
                      <b>ХАЯГ:</b>&nbsp;"ДРАГОН" автовокзалын зүүн талд, Золт худалдааны төвийн 2 давхарт
                    </p>
                  </div>
                  <div
                    style="padding:20px; border-left:5px solid #f26322;  border-right:1px solid #f26322;"
                  >
                    <p>
                      <b>Цагийн хуваарь:</b>
                      <br />Өдөр бүр: 09:00 - 18:00
                    </p>
                  </div>
                  <div
                    style="padding:20px; background-color:#f1f1f1;  border-right:5px solid #f26322;  border-left:1px solid #f26322;"
                  >
                    <div style>
                      Хүлээн авагч төхөөрөмжийн үнэ:
                      <span style="font-size: 12pt;">150 000₮</span>
                      <br />Антен /60см/, дуран, кабелийн багц үнэ:
                      <br />
                      <span style="font-size: 12pt;">35 000₮</span>
                      <br />
                    </div>
                  </div>
                  <div style="border-bottom:5px solid #f26322; ">
                    <img
                      src="../assets/img/zolt.jpg"
                      class="img-responsive"
                      style=" width: 100%;"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--/.team_single-->
          </div>
          <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.2s">
            <div class="team_single">
              <div style="padding-top:0px; text-align:left;">
                <div class="padding-top-bottom-content" style="background-color:#003355;">
                  <h3 style="color: white; margin-bottom: 0px; padding-left: 20px;">
                    <span style="font-family: &quot;Times New Roman&quot;;">"ОФИЦЕР" зах</span>
                  </h3>
                </div>
                <div>
                  <div
                    style="padding:20px; background-color:#f1f1f1; border-right:5px solid #003355; border-left:1px solid #003355;"
                  >
                    <p>
                      <b>ХАЯГ:</b>Офицеруудын ордноос уруудаад "ОФИЦЕР" захын B1 давхарт (Тэнгэр худалдааны төвийн эсрэг талд)
                    </p>
                  </div>
                  <div
                    style="padding:20px; background-color:#fff; border-right:1px solid #003355; border-left:5px solid #003355;"
                  >
                    <p>
                      <b>Цагийн хуваарь:</b>
                      <br />Мягмар - Ням : 09:00 - 18:00
                      <br />Даваа гарагт амарна.
                    </p>
                  </div>
                  <div
                    style="padding:20px; background-color:#f1f1f1; border-right: 5px solid #003355; border-left: 1px solid #003355;"
                  >
                    <p style>
                      Хүлээн авагч төхөөрөмжийн үнэ:
                      <span style="font-size: 12pt;">150 000₮</span>
                      <br />Антен /60см/, дуран, кабелийн багц үнэ:
                      <br />
                      <span style="font-size: 12pt;">35 000₮</span>
                    </p>
                  </div>

                  <div style="border-bottom:5px solid #003355;">
                    <img
                      src="../assets/img/oficer.jpg"
                      class="img-responsive"
                      style="width: 100%;"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--/.team_single-->
          </div>
          <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.3s">
            <div class="team_single">
              <div style="padding-top:0px; text-align:left;">
                <div class="padding-top-bottom-content" style="background-color:#2e7d32;">
                  <h3 style="color: white; margin-bottom: 0px; padding-left: 20px;">
                    <span style="font-family: &quot;Times New Roman&quot;;">"АМУ" төв</span>
                  </h3>
                </div>
                <div>
                  <div
                    style="padding:20px; background-color:#f1f1f1; border-right:5px solid #2e7d32; border-left:1px solid #2e7d32;"
                  >
                    <p>
                      <b>ХАЯГ:</b>
                      <br />7 буудлын эцэст "АМУ"&nbsp;төвийн 2 давхарт
                    </p>
                  </div>
                  <div
                    style="padding:20px; background-color:#fff; border-right:1px solid #2e7d32; border-left:5px solid #2e7d32;"
                  >
                    <p>
                      <b>Цагийн хуваарь:</b>
                      <br />Даваа - Бямба: 10:00 - 19:00
                      <br />Ням гарагт амарна.
                    </p>
                  </div>
                  <div
                    style="padding: 20px; border-right: 5px solid #2e7d32; border-left: 1px solid #2e7d32;"
                  >
                    <p style>
                      Хүлээн авагч төхөөрөмжийн үнэ:
                      <span style="font-size: 12pt;">150 000₮</span>
                      <br />Антен /60см/, дуран, кабелийн багц үнэ:
                      <br />
                      <span style="font-size: 12pt;">35 000₮</span>
                    </p>
                  </div>
                  <div s style="border-bottom:5px solid #2e7d32;">
                    <img
                      src="../assets/img/amu.jpg"
                      class="img-responsive"
                      style=" width: 100%;"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--/.team_single-->
          </div>

        </div>
      </div>
      <!--/.container-->
    </section>
  </div>
</template>
<script>
export default {
  name: "tvChannel",
  components: {}
};
</script>